// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__I6r5o","title":"ClientReferral_title__2A14p","itemText":"ClientReferral_itemText__1LrjM"};